import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const MessageWrapper = styled.div`
  padding: 60px 0;
`;

export const ActionWaiting = styled.div`
  font-size: 16px;
`;

export const ActionButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;

export const PersonDataTableContainer = styled.div`
  .hover-button-wrapper {
    visibility: hidden;
  }

  .rdt_TableRow:hover .hover-button-wrapper {
    visibility: visible;
  }
`;

export const FormWrapper = styled.div`
  font-size: 12px;
  background-color: #fff;
  margin-top: 25px;

  .error-msg {
    color: red;
    margin-left: 10px;
  }
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
`;

export const MultiColRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .col {
    flex: 1;
    flex-direction: row;
  }
`;

export const FormItem = styled.div`
  padding-bottom: 22px;
  font-weight: 300;
  color: #6c7488;
  position: relative;

  .error-msg {
    margin-left: 5px;
    color: red;
    font-size: 12px;
  }
  .fileUpload {
    display: none;
  }
  .uploadButton {
    display: block;
    margin-top: 30px;
    cursor: pointer;
    font-size: large;
  }
  .pending {
    font-style: italic;
  }
  .react-select-container {
    margin-bottom: 5px;
  }
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-bottom: 5px;
`;

export const FormCheckbox = styled.input`
  display: inline-block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-left: 20px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}

export const VInput = styled(Input)<VInputProps>`
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  margin-bottom: 5px;
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const TableHeader = styled.div`
  display: flex;
  display: flex;
  justify-content: space-between;
`;

export const AddNewPerson = styled.button`
  color: blue;
  cursor: pointer;
  background: none;
  border: none;
  margin-right: 40px;
`;

export const SubTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin: 20px 0 15px;
  color: #6c7488;
`;

export const ModalFileWrapper = styled.div`
  padding: 20px 0;
  .loading-msg {
    margin: 20px 0;
    color: grey;
  }
  img {
    width: 100%;
  }
`;

export const ViewFileButton = styled.button`
  background: none;
  border: none;
  color: blue;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: 10px;
`;

export const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 24px;

  button {
    cursor: pointer;
    display: none;
    background: none;
    border: none;
  }
  &:hover button {
    display: block;
  }
`;
